(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["born-prelaunch-signup"] && !Shopify.designMode) return;
  try {
    function initializeBornPrelaunchFeedback() {
  const form = document.getElementById('BornPrelaunchSignup');
  const feedback = document.getElementById('BornPrelaunchFeedback');
  const success = document.getElementById('BornPrelaunchSuccess');
  if (success) success.focus();
  if (!form || !feedback || form.dataset.feedbackReady) return;
  form.dataset.feedbackReady = 'true';
  let timer;
  form.addEventListener('submit', function () {
    if (!form.checkValidity()) return;
    clearTimeout(timer);
    feedback.textContent = feedback.dataset.submitting;
    feedback.style.padding = '16px 0';
    timer = setTimeout(function () {
      feedback.textContent = feedback.dataset.pending;
    }, 20000);
  }, true);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBornPrelaunchFeedback);
} else {
  initializeBornPrelaunchFeedback();
}
document.addEventListener('shopify:section:load', initializeBornPrelaunchFeedback);
  } catch(e) { console.error(e); }
})();

})();
